import apiClient from "@/libs/axios";

export const state = {
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    }
}

export const mutations = {
    SET_DATA(state, data) {
        state.data = data.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },
}

export const actions = {
    async get({ commit }, data) {
        let filters = window.mapFilterData(data);
        console.log(filters);
        await apiClient
            .get(`api/v1/vendors/revenue${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('SET_DATA', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
}

export const getters = {
    getData: (state) => {
        return state.data;
    },
    getTotal(state) {
        return state.total;
    },
}